import { Visita } from "../../../../types/deal";
import { parseTaskDate, reverseDate } from "../../../../utils/calendarUtils";
import { Convert24HoursTo12HoursFormat } from "../../../../utils/convertTimeFormat";
import { Turnos } from "../../../../utils/enums";
import { Dispatch, SetStateAction } from "react";
import { CurrentComponent } from "./DealInformation";
import DoneRoundedIcon from '@mui/icons-material/DoneRounded';

interface Props {
    visitas: Visita[];
    setCurrentComponent: Dispatch<SetStateAction<CurrentComponent>>;
}

export function VisitaList({ visitas, setCurrentComponent }: Props) {

    const handleSelectedVisita = (visitaId: number) => {
        setCurrentComponent({
            component: "Visita",
            visitaId: visitaId,
        });
    }

    return (
        <div className="rounded h-full overflow-auto">
            {visitas.length === 0
            ? 
            <p className="text-sm font-semibold text-gray-600 italic text-center m-2">No hay visitas agregadas</p>
            :
            visitas.map((visita, index) => {
                const horaInicio = Convert24HoursTo12HoursFormat(visita.horaInicio);
                const horaFin = Convert24HoursTo12HoursFormat(visita.horaFin);
                const fecha = reverseDate(parseTaskDate(visita.fecha));
                let turno = visita.turno;
                
                if(typeof visita.turno == "number")
                    turno = Turnos[visita.turno];

                return (
                    <div 
                        key={index}
                        onClick={() => handleSelectedVisita(visita.id)}
                        className="flex justify-between hover:bg-slate-200 p-2 rounded-md bg-slate-50 border border-gray-500 my-2 mx-1 cursor-pointer">
                        <div className="flex gap-x-4 items-center justify-center">
                            {visita.terminado
                            ?
                            <div className="border-2 border-red-400 bg-red-100 h-[20px] w-[20px] rounded-full flex justify-center items-center">
                                <DoneRoundedIcon sx={{
                                    height: 20,
                                    width: 20,
                                    color: "#f87171",
                                }}/>
                            </div>
                            :
                            <div className="border-2 border-green-400 bg-green-100 h-[20px] w-[20px] rounded-full flex justify-center items-center">
                            </div>
                            }

                            <div className="flex gap-x-1">
                                <p className="text-sm font-semibold">{fecha}</p>
                            </div>
                            <div>
                                <p className="text-sm font-semibold">Turno: {turno}</p>
                            </div>

                            <div>
                                <p className="text-sm font-semibold">Hora de inicio: {horaInicio}</p>
                            </div>

                            <div>
                                <p className="text-sm font-semibold">Hora de fin: {horaFin}</p>
                            </div>
                        </div>

                    </div>
                );
            }) 
            }
        </div> 
    );
}